export const FILTER_TYPE = {
  DEVICE: {
    NAME: "device_name",
    ID: "device_id",
    ORIGINAL_NAME: "on_device_name",
    LOCATION_NAME: "location_name",
    LOCATION_DESC: "location_description",
    LAST_INSIGHT_HOUR: "last_insight",
    LAST_IMAGE_HOUR: "last_image",
    LATITUDE: "lat",
    LONGITUDE: "long",
    CYCLE_TIME: "cycle_time",
    TRIGGER_NUMBER: "trigger_number",
    MEMORY_REMAINING: "memory_remaining",
    CYCLE_COUNT: "cycle_count",
    IMAGES_PROCESSED: "images_processed",
    GROUPS: "groups",
    BATTERY_VOLTAGE: "battery_voltage",
    LAST_SEEN: "last_seen",
    UPDATE_STATUS: "device_update_status",
    BATTERY_STATUS: "battery_status",
    MAP_BUTTON: "map_button",
    WIFI_INSIGHTS: "wifi_insights",
    WIFI_IMAGES: "wifi_images",
    LORA_ID: "lora_id",
    CODE_VERSION: "code_version",
    MAC_ID: "mac_id",
    MCU_VERISON: "mcu_version",
    CELL_UID: "cell_uid",
    LAST_CYCLE_COUNT_HOUR: "last_cycle_count"
  },
  INSIGHT: {
    CLASS_NAME: "class_name",
    ALL_CLASS_NAMES: "all_class_names",
    ALG_ID: "insight_alg_id",
    CONFIDENCE: "insight_confidence",
    TIMESTAMP: "time_stamp",
    FILE_CTIME: "file_ctime",
    COMMS_SOURCE: "insight_comms_source",
    IMAGE: "insight_image",
    STATUS: "insight_status",
    ACTIONS: "insight_actions"
  },
  ALERT: {
    STATUS_ICON: "alert_status_icon",
    STATUS_TEXT: "alert_status_text",
    TYPE: "alert_type",
    SUMMARY: "alert_summary",
    KEY: "alert_key",
    ASSOCIATED_ID: "alert_associated_id",
    CREATED_AT: "alert_created_at",
    ACTION: "alert_action"
  },
  UPDATES: {
    OVERALL_STATUS: "update_overall_status",
    ID: "update_id",
    ALG_RELEASE_ID: "update_alg_release_id",
    FIRMWARE_VERSION: "update_firmware_version",
    CREATED_ON: "update_created_on",
    CYCLE_TIME: "update_cycle_time",
    TRIGGER_NUMBER: "update_trigger_number",
    DEVICE_COUNT: "update_device_count",
    DEVICE_IDS: "update_device_ids"
  },
  USER: {
    ID: "user_id",
    EMAIL: "user_email",
    USERNAME: "username",
    FIRST_NAME: "first_name",
    LAST_NAME: "last_name",
    PHONE_NUMBER: "phone_number"
  },
  ALG_META: {
    ID: "meta_alg_id",
    NAME: "meta_alg_name",
    FRAMEWORK: "meta_framework",
    DATE_CREATED: "meta_date_created",
    BUCKET: "meta_alg_bucket",
    PATH: "meta_alg_path",
    CHECKSUM: "meta_md5_checksum",
  },
  ALG_RELEASE: {
    ID: "release_id",
    NAME: "release_name",
    FRAMEWORK: "release_description",
    MODEL_COUNT: "release_model_count",
    MODEL_IDS: "release_model_ids",
    NORMALIZATION: "release_image_normalization_methods",
    SENSITIVITY: "release_sensitivity"
  }
}

export const DATA_TYPES = {
  STRING: "string",
  NUMBER: "number",
  DATE: "date",
  ELEMENT: "element",
  LIST: "list",
  PERCENT: "percent"
}

export const DATA_SCOPES = {
  DEVICE: "device",
  INSIGHT: "insight",
  ALERT: "alert",
  UPDATES: "updates",
  USERS: "users",
  ALG_META: "alg_meta",
  ALG_RELEASE: "alg_release",
  ALL: "all"
}